import React, {
  useEffect, useRef, useState
} from 'react';
// useCallback
import moment from 'moment';
import { Link, browserHistory } from 'react-router';
// import { useLongPress } from 'use-long-press';
import Select2 from 'react-select2-wrapper';
import DatePicker from 'react-datepicker';
import Datetime from 'react-datetime';
// import Lightbox from 'react-image-lightbox';
import _ from 'lodash';
import {
  getTerritoryData,
  handleProductsButtonClick,
  isMobile
} from '../common/globals';
// import { isMobile, LONG_PRESS_PARAMS } from '../common/globals';
import withTeam from '../common/withTeam';
import withGoBack from '../common/withGoBack';
import withLoader from '../common/withLoader';
import withTableName from '../common/withTableName';
import withNotify from '../common/withNotify';
import withOnline from '../common/withOnline';
import withProducts from '../common/withProducts';
import Bugsnag from '../helpers/bugsnag';
import CaseChangesNoLonger from './Models/CasesChangesNoLonger';
import {
  getTableCaseByCaseId,
  getVhnPpcValue,
  updateTableWiseCaseByCaseId,
  getHospitalByCustomerNo,
} from '../utils/db';
import {
  updateCase,
  uploadDgr
} from '../utils/utils';
import DgrRequiredOnSubmitCase from './Models/DgrRequiredOnSubmitCase';
import PdfIcon from '../assets/images/file-pdf-box.png';
import AcmFlag from '../assets/images/flag.png';
import caseHistoryFlag from '../assets/images/history-custom.png';
import XrayIcon from '../assets/images/radiology-box-outline.png';
import CloseIcon from '../assets/images/close.png';
import DollarSign from '../assets/images/dollarSign.png';
import ArrowRight from '../assets/images/arrow-right.png';
import FileIcon from '../assets/images/file-document-outline.png';
import ImageWithLoader from './ImageWithLoader.js';
import withDerModal from '../common/withDerModal.js';
import ACMRightArrow from '../assets/images/right-arrowACM.png';
import ACMRightArrowDark from '../assets/images/right-arrowACM_dark.png';
import withThemeColor from '../common/withThemeColor.js';

function EditCaseDetail(props) {
  const {
    caseDetail: {
      Submitted,
      SurgeonName,
      CoverRep,
      CustomerName,
      CaseType,
      ProcedureType,
      Side,
      PatientID,
      Gender,
      Age,
      Height,
      Weight,
      MRN,
      RepPONumber,
      RepNotes,
      Comments,
      case_xrays,
      case_products,
      ACMCaseID,
      ProductSubmitted,
      CaseScheduleID,
      SurgeonNotes,
      ACMPlannedParts,
      ACMCaseFlags,
      CaseNo,
      AltCaseType,
      ACMRepLock,
      CreateRep,
      HeightUnits,
      WeightUnits,
      ACMCaseID2,
      CustCaseID,
    },
    selectedDate,
    selectedTime,
    isEditDetail,
    sides,
    coverReps,
    types,
    AddVhnPpc,
    AddVrasPpc,
    procedures,
    surgeons,
    hospitals,
    genders,
    onSetsClick,
    onBillingDetails,
    onChangeCaseDetail,
    onProduct,
    caseDetail,
    onCancelCase,
    onCustomerNo,
    team: {
      dgrRequired
    },
    caseId,
    caseRes,
    online,
    notify,
    user,
    screenWidth,
    tableName,
    setLoader,
    xRayFileUrlData,
    themeColor,
    onCustomerCaseAdd,
  } = props;

  const caseChangesNoLonger = null;
  let dgrRequiredOnSubmitCaseModal = null;
  // const [photoIndex, setPhotoIndex] = useState(0);
  // const [isOpen, setIsOpen] = useState(false);
  const [acmPlanned, setAcmPlanned] = useState([]);
  const [xRayFileUrlDataToShow, setXRayFileUrlDataToShow] = useState([]);
  const [xRayCount, setXRayCount] = useState(0);
  const [acmRepLockData, setAcmRepLockData] = useState([]);

  let setsQuantity;
  // let cancelCaseModal = null;
  const pickerRef = useRef(null);
  const ShowPushACM = (ACMCaseID2 !== null && CreateRep !== 'ACM');
  const ShowACM = (ACMCaseID !== null && CreateRep === 'ACM');

  const [hospitalUseCustCaseIDStatus, setHospitalUseCustCaseIDStatus] = useState(false);

  useEffect(() => {
    if (isMobile && pickerRef.current !== null) {
      pickerRef.current.input.readOnly = true;
    }
  }, [isMobile, pickerRef]);

  useEffect(() => {
    if (!_.isEmpty(ACMPlannedParts)) {
      const plannedArr = [];
      const ACMPlannedArray = ACMPlannedParts.split(';');
      ACMPlannedArray.map((value) => {
        plannedArr.push(value.split(','));
      });
      const plannedValue = plannedArr.slice(0).map(
        ([productId, bodyComponent, confidence, isTemplated, shortDesc, longDesc]) => ({
          productId, bodyComponent, confidence, isTemplated, shortDesc, longDesc
        })
      );

      const templatedPlannedData = [];
      for (const planned of plannedValue) {
        if (!_.isEmpty(planned.longDesc)) {
          templatedPlannedData.push(planned);
        }
      }
      setAcmPlanned(templatedPlannedData);
    }

    if (typeof ACMCaseID !== 'undefined' && ACMCaseID !== null && typeof ACMRepLock !== 'undefined' && ACMRepLock !== null && ACMRepLock !== '') {
      const ACMPlannedArray = ACMRepLock.split(',').map((item) => item.toUpperCase());
      setAcmRepLockData(ACMPlannedArray);
    }
  }, []);

  useEffect(() => {
    // console.log('xRayFileUrlData', xRayFileUrlData);
    if (xRayFileUrlData.length && !Object.hasOwn(xRayFileUrlData[0], 'type')) {
      if (xRayFileUrlData.length <= 20) {
        setXRayCount(xRayFileUrlData.length);
        setXRayFileUrlDataToShow(xRayFileUrlData);
        return;
      }
      setXRayFileUrlDataToShow(xRayFileUrlData.slice(0, 20));
      return;
    }
    let tempCount = 0;
    const tempXRayFileUrlData = [];
    xRayFileUrlData.forEach((type) => {
      if (tempCount + type.files.length <= 20) {
        tempXRayFileUrlData.push(type);
      } else if (tempCount <= 20) {
        tempXRayFileUrlData.push({
          ...type,
          files: type.files.slice(0, 20 - tempCount)
        });
      }
      tempCount += type.files.length;
    });
    setXRayCount(tempCount);
    setXRayFileUrlDataToShow(tempXRayFileUrlData);
  }, [xRayFileUrlData]);

  // const _onLongPress = useCallback((event, key) => {
  //   try {
  //     if (screenWidth > 800) {
  //       if (DGR === '1') {
  //         caseChangesNoLonger = new window.bootstrap.Modal(
  //         window.$('#CaseChangesNoLongerModal'));
  //         caseChangesNoLonger.show();
  //         return;
  //       }
  //       if (!Object.values(isEditDetail).some((field) => field === true)) {
  //         onEditCaseDetail(key, !isEditDetail[key]);
  //       }
  //     }
  //   } catch (e) {
  //     Bugsnag.notify(e);
  //   }
  // }, [isEditDetail, onEditCaseDetail]);

  const _onGoBack = () => {
    try {
      const { goBack, setGoBack } = props;
      goBack.push(window.location.pathname);
      setGoBack(goBack);
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  useEffect(() => {
    const { derModal, setDerModal, refreshCaseData } = props;
    try {
      if (derModal.answer) {
        const handleModalAnswer = async () => {
          const updatedCase = {
            ...props.caseDetail,
            DERRequired: derModal.answer.toUpperCase() === 'YES' ? '1' : '0'
          };
          if (online) {
            await updateCase(updatedCase);
            updateTableWiseCaseByCaseId(updatedCase.RepCaseNo, updatedCase, tableName);
          } else {
            updatedCase.Sync = 1;
            updateTableWiseCaseByCaseId(updatedCase.RepCaseNo, updatedCase, tableName);
          }
          await refreshCaseData();
          await _onProduct();
          setDerModal({ ...derModal, answer: null, for: null });
        };
        setLoader(true);
        handleModalAnswer().finally(() => setLoader(false));
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }, [props.derModal]);

  const onBeforeProduct = () => {
    try {
      const { setDerModal, caseDetail: { DERRequired } } = props;
      const territory = getTerritoryData(user);
      if (territory
        && territory.isDER
        && typeof ProcedureType !== 'undefined'
        && ProcedureType !== null
        && ProcedureType.toUpperCase() === 'REVISION'
        && (DERRequired === null || DERRequired === undefined)) {
        setDerModal({ show: true });
        return;
      }
      _onProduct();
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  let vhnPpcValue = {};
  const _onProduct = async () => {
    try {
      if (Object.values(isEditDetail).includes(true)) {
        return;
      }
      const { setProducts } = props;
      if (CustomerName !== null) {
        const vhnPpc = await getVhnPpcValue(CustomerName);
        if (typeof vhnPpc !== 'undefined') {
          vhnPpcValue = vhnPpc;
        }
      }
      setProducts([]);
      const resultedRoute = handleProductsButtonClick(
        online,
        caseDetail,
        selectedDate,
        {
          addPatientIdOrMrn: onProduct,
          addCustomerCaseID: onCustomerCaseAdd,
          addVhnPpc: AddVhnPpc,
          addVrasPpc: AddVrasPpc
        },
        user.scanner,
        vhnPpcValue.VHN_PPC,
        vhnPpcValue.VHN_Other,
        vhnPpcValue.VRAS_PPC,
        vhnPpcValue.VRAS_Other,
        notify,
        hospitalUseCustCaseIDStatus
      );
      if (resultedRoute) {
        _onGoBack();
        browserHistory.push(resultedRoute);
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  if (Object.keys(caseRes).length > 0) {
    setsQuantity = caseRes.case_sets.reduce(
      (sum, { Quantity }) => sum + parseInt(Quantity, 10), 0
    );
  }

  const _onCancelCase = () => {
    try {
      if (Object.values(isEditDetail).includes(true)) {
        return;
      }
      onCancelCase();
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  const _onSubmitCase = async () => {
    try {
      if (Object.values(isEditDetail).includes(true)) {
        return;
      }
      const { onSubmitCase, onCaseSubmitted } = props;
      const newUpdatedCaseDetail = await getTableCaseByCaseId(caseId, tableName);
      console.log(dgrRequired);
      console.log(newUpdatedCaseDetail);
      if (online && newUpdatedCaseDetail.case_products.length > 0
        && newUpdatedCaseDetail.ProductSubmitted === '0' && dgrRequired === 6 && newUpdatedCaseDetail.case_dgrs.length === 0) {
        dgrRequiredOnSubmitCaseModal = new window.bootstrap.Modal(window.$(`#dgrRequiredOnSubmitCaseModal-${caseId}`));
        dgrRequiredOnSubmitCaseModal.show();
        return;
      }
      (Submitted === '1' && ProductSubmitted === '1')
        ? onCaseSubmitted()
        // : (Submitted === '1' && Synced === '1')
        //   ? onCaseSubmitted()
        : onSubmitCase();
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  // const _onCancelCase = () => {
  //   if (online) {
  //     cancelCaseModal = new window.bootstrap.Modal(window.$('#cancelCaseModal'));
  //     cancelCaseModal.show();
  //   } else {
  //     notify({ type: 'error',
  //     message: 'You must have an internet connection.
  //     Please check your connection and try again.',
  //     time: 3 });
  //   }
  // };

  const _onSets = () => {
    try {
      if (Object.values(isEditDetail).includes(true)) {
        return;
      }
      if (online && CaseScheduleID !== null) {
        onSetsClick();
      } else if (online && CaseScheduleID === null) {
        notify({ type: 'error', message: 'Case must be submitted and have a CaseNo before adding sets.', time: 3 });
      } else {
        notify({ type: 'error', message: 'You must be connected to the internet to view sets.', time: 3 });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  const _onXrays = () => {
    try {
      if (Object.values(isEditDetail).includes(true)) {
        return;
      }
      if (online) {
        _onGoBack();
        browserHistory.push(`/manage-case/${caseId}/x-ray`);
      } else {
        notify({ type: 'error', message: 'X-rays cannot be viewed without an internet connection.', time: 3 });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  const _onBillingDetails = () => {
    try {
      if (Object.values(isEditDetail).includes(true)) {
        return;
      }
      if (online) {
        onBillingDetails();
      } else {
        notify({ type: 'error', message: 'You must have an internet connection. Please check your connection and try again.', time: 3 });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  const _maxLengthCheck = (object) => {
    try {
      if (object.target.value.length > object.target.maxLength) {
        object.target.value = object.target.value.slice(0, object.target.maxLength);
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  const inputProps = {
    id: 'date-picker-input2',
    disabled: (ACMCaseID !== null),
  };

  const timeConstraints = {
    minutes: {
      step: 15
    }
  };

  const _getCustomerNo = async (name) => {
    try {
      onCustomerNo(name);
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  const _getHospital = () => {
    try {
      $('#hospitalsEle1').select2('open');
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  const onSelectImage = async (formData) => {
    try {
      const uploadFile = document.getElementById(`uploadDGREle-${caseId}`);
      const caseDetailsRes = await getTableCaseByCaseId(caseId, tableName);
      console.log(caseChangesNoLonger);
      // if (caseDetailsRes && caseDetailsRes.DGR === '1') {
      //   caseChangesNoLonger.show();
      //   return;
      // }

      const body = formData.files[0];
      if (!(/\.(gif|jpg|jpeg|tiff|png|pdf|heic)$/i).test(body.name)) {
        notify({ type: 'error', message: 'Only images and PDF files are allowed for DGR uploads.' });
        return;
      }
      setLoader(true);
      if (online) {
        uploadDgr({
          CaseScheduleID: caseDetailsRes.CaseScheduleID,
          OriginalFile: body
        }).then(async (responseJson) => {
          setLoader(false);
          const {
            message, data, result
          } = responseJson;
          if (result === 'success') {
            if (message.length > 0) {
              //  if (screenWidth < 800) {
              window.location = `/manage-case/${caseId}/products/dgr`;
              // }
              uploadFile.value = null;
            }
            // _onGoBack();
            // Update into local db
            caseDetailsRes.case_dgrs.push(data);
            await updateCase(caseDetailsRes);
            await updateTableWiseCaseByCaseId(caseDetailsRes.RepCaseNo, caseDetailsRes, tableName);
          } else if (result === 'failure') {
            notify({ type: 'error', message });
          } else {
            notify({ type: 'error', message });
          }
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  const onClickDrgModalYes = () => {
    try {
      if (online) {
        // _onGoBack();
        document.getElementById(`uploadDGREle-${caseId}`).click();
      } else {
        notify({ type: 'error', message: 'DGRs cannot be viewed without an internet connection' });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  const onRedirectToDgr = () => {
    try {
      setTimeout(() => {
        const { goBack, setGoBack } = props;
        const uploadFile = document.getElementById(`uploadDGREle-${caseId}`);
        _onGoBack();
        if (uploadFile !== null && uploadFile.value.length) {
        } else {
          if (goBack.length === 3 && goBack[goBack.length - 2] === `/manage-case/${caseId}`) {
            setGoBack(['/manage-cases', `/manage-case/${caseId}`]);
            return;
          }
          if (goBack.length === 4) {
            if (goBack[goBack.length - 3] === '/missing-dgr') {
              setGoBack(['/billing', '/missing-dgr', `/manage-case/${caseId}`]);
              return;
            }
            if (goBack[goBack.length - 3] === '/missing-pos') {
              setGoBack(['/billing', '/missing-pos', `/manage-case/${caseId}`]);
              return;
            }
            if (goBack[goBack.length - 3] === '/billing/notBilledCases') {
              setGoBack(['/billing', '/billing/notBilledCases', `/manage-case/${caseId}`]);
              return;
            }
          }
          if (goBack.length === 5 && goBack[goBack.length - 2] === `/manage-case/${caseId}`) {
            setGoBack(['/manage-cases', '/manage-cases/filter',
              '/manage-cases/filter-cases', `/manage-case/${caseId}`]);
            return;
          }
          // setGoBack(goBack);
          browserHistory.push(`/manage-case/${caseId}/products/dgr`);
        }
        document.body.onfocus = null;
      }, 1000);
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  const onCancelUploadImage = () => {
    try {
      document.body.onfocus = onRedirectToDgr;
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  const _getOfficeSets = () => {
    try {
      if (Object.keys(caseRes).length > 0) {
        const result = [...caseRes.case_sets.reduce((mp, o) => {
          if (!mp.has(o.SetName)) mp.set(o.SetName, { ...o, count: 0 });
          mp.get(o.SetName).count++;
          return mp;
        }, new Map()).values()];
        const groupByData = _.groupBy(result, 'DeviceType');
        const sorted = Object.keys(groupByData)
          .sort()
          .reduce((accumulator, key) => {
            accumulator[key] = groupByData[key];
            return accumulator;
          }, {});
        return sorted;
      }
      return [];
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  const onFlag = () => {
    try {
      const { goBack } = props;
      goBack.push(window.location.pathname);
      browserHistory.push(`/manage-case/${caseId}/acm-products/acmFlagDetails`);
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  const onHistoryFlag = () => {
    try {
      const { goBack, setTableName, setGoBack } = props;
      setTableName('Cases');
      goBack.push(window.location.pathname);
      setGoBack(goBack);
      browserHistory.push(`/manage-case/${caseId}/case-history`);
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  const onImage = (image) => {
    window.open(image.src, '_blank');
  };

  const LoopComponent = ({ setData }) => {
    const items = [];
    for (let i = 0; i < Number(setData.Quantity); i++) {
      items.push(
        <tr className={i + Number(setData.Quantity) * 10} key={i + Number(setData.Quantity) * 10}>
          <td className="col-11">{setData.SetName}</td>
          <td className="col-1 text-center">
            {
              typeof setData.SetNo !== 'undefined' && setData.SetNo !== null
                ? (
                  setData.SetNo.length > 2 ? setData.SetNo.slice(0, 2) : setData.SetNo
                )
                : ''
            }
          </td>
        </tr>
      );
    }

    return (
      <>
        {items}
      </>
    );
  };

  const getTotalQuantity = (caseSetArray, deviceType, $flag) => {
    if (typeof caseSetArray !== 'undefined' && caseSetArray.length > 0) {
      return caseSetArray.reduce((sum, item) => {
        if ($flag) {
          if (item.DeviceType === deviceType && item.Status === null) {
            return sum + Number(item.Quantity);
          }
        } else {
          if (item.DeviceType === deviceType) {
            return sum + Number(item.Quantity);
          }
        }

        return sum;
      }, 0);
    }
    return 0;
  };

  useEffect(async () => {
    if (typeof caseDetail.CustomerNo !== 'undefined' && caseDetail.CustomerNo !== null) {
      const hosptalRes = await getHospitalByCustomerNo(caseDetail.CustomerNo);

      if (typeof hosptalRes !== 'undefined' && hosptalRes !== null) {
        if (
          hosptalRes.UseCustCaseID === '1'
          // && caseDetail.CustCaseID === null
          // && (caseDetail.ProductSubmitted === null || caseDetail.ProductSubmitted !== '1')
        ) {
          setHospitalUseCustCaseIDStatus(true);
        }
      }
    }
  }, []);

  return (
    <>
      <section className={`case-details-section manage-session resizer-class ${Submitted === 0 ? 'submitted-case' : ''}`}>
        <input
          id={`uploadDGREle-${caseId}`}
          accept="image/*,.pdf"
          type="file"
          capture="capture"
          onClick={onCancelUploadImage}
          onChange={(e) => onSelectImage(e.target)} className="d-none"
        />
        <div className="container">
          {
            !(Submitted === '1' && (ProductSubmitted === '1' || ProductSubmitted === null))
            && (
              <div className="d-flex justify-content-center mb-2">
                <div className="col-6 col-md-4">
                  <Link
                    className="btn btn-red-border d-block"
                    onClick={_onSubmitCase}
                  >Submit <span> <img width="24px" src={ArrowRight} alt="arrow" /></span>
                  </Link>
                </div>
              </div>
            )
          }

          <div className="row gx-2 case-data mb-1">
            <div className="col-2"><label htmlFor="caseId">Case ID:</label></div>
            <div className="col-10">

              <p style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span>
                  {CaseNo === null ? 'PENDING' : CaseNo}
                  {
                    PatientID !== null && PatientID !== undefined && PatientID.startsWith('ACM CX') && (
                      <span className="acm-cx d-inline-block" style={{ paddingLeft: '30px' }}> (ACM CX)</span>
                    )
                  }
                  {
                    ShowACM && (
                      <span style={{ paddingLeft: '10px' }}>ACM</span>
                    )
                  }
                  {
                    ShowPushACM && (
                      <>
                        <span className="fixed-space" style={{ paddingLeft: '30px' }}>
                          <img width="16px" src={themeColor === 'light' ? ACMRightArrowDark : ACMRightArrow} alt="flag" />
                        </span>
                        <span className="position-relative" style={{ paddingLeft: '10px', top: '2px' }}>ACM</span>
                      </>
                    )
                  }
                </span>

                <span>
                  {
                    ACMCaseFlags !== null && ACMCaseFlags !== undefined && ACMCaseFlags !== '' && (
                      <span className="cursor-pointer" onClick={onFlag}>
                        <img width="25px" src={AcmFlag} alt="ACM" />
                      </span>
                    )
                  }
                  <span className="cursor-pointer ml-10" onClick={onHistoryFlag}>
                    <img width="25px" src={caseHistoryFlag} alt="Case History" />
                  </span>
                </span>
              </p>

            </div>
          </div>

          {
            hospitalUseCustCaseIDStatus && (
              <div className="row gx-2 case-data mb-1">
                <div className="col-2"><label htmlFor="CustCaseID">Cust ID:</label></div>
                <div className="col-9">
                  {
                    isEditDetail.CustCaseID
                      ? (
                        ''
                      )
                      : (
                        <span
                          className="theme-color-white"
                        > {CustCaseID}
                        </span>
                      )
                  }
                </div>
              </div>
            )
          }

          <div className="row gx-2 case-data mb-1">
            <div className="col-2"><label htmlFor="caseId">Date:</label></div>
            <div className="col-9">
              {
                isEditDetail.selectedDate
                  ? (
                    <DatePicker
                      dateFormat="E MMM d, y"
                      className="form-control date-picker-read-only"
                      id="onSelect2FocusEdit"
                      // placeholderText="Start Date"
                      selected={selectedDate}
                      onChange={(value) => {
                        onChangeCaseDetail('selectedDate', value);
                      }}
                      onChangeRaw={(e) => {
                        e.preventDefault();
                      }}
                      ref={pickerRef}
                      disabled={(ACMCaseID !== null)}
                    />
                  )
                  : (
                    // COMMENT currently quick edit functionality disabled
                    // <span
                    //   {...useLongPress((event) => {
                    //     online && ACMCaseID !== null
                    //       ? notify({ type: 'warning',
                    //       message: 'This ACM case. You can\'t edit this value.' })
                    //       : online
                    //         ? _onLongPress(event, 'selectedDate')
                    //         : notify({ type: 'error',
                    //         message: 'You need an internet connection to edit this case.',
                    //         time: 5 });
                    //   },
                    //   LONG_PRESS_PARAMS)}
                    //   className={`cursor-pointer theme-color${
                    //   (ACMCaseID === null && screenWidth > 800) ? '-yellow'
                    //     : ((ACMCaseID === null || ACMCaseID !== null)
                    //     && screenWidth < 800) ? '-white'
                    //       : ((ACMCaseID === null || ACMCaseID !== null)
                    //       && (screenWidth > 800 || screenWidth < 800)) && '-white'}`}
                    // >{moment(selectedDate).format('ddd MMM DD, YYYY')}
                    // </span>
                    <span
                      className={`theme-color-white ${acmRepLockData.includes('CASEDATE') ? 'blue-text' : ''}`}
                    > {moment(selectedDate).format('ddd MMM DD, YYYY')}
                    </span>
                  )
              }
              {
                isEditDetail.selectedTime
                  ? (
                    <Datetime
                      dateFormat={false}
                      onChange={(value) => {
                        onChangeCaseDetail('selectedTime', value);
                      }}
                      nChangeRaw={(e) => {
                        e.preventDefault();
                      }}
                      className="time-border date-picker-read-only time-picker-bg-white"
                      inputProps={inputProps}
                      timeConstraints={timeConstraints}
                      input={false}
                      value={selectedTime}
                      disabled={(ACMCaseID !== null)}
                    />
                  )
                  : (
                    // COMMENT currently quick edit functionality disabled
                    // <span
                    //   {...useLongPress((event) => {
                    //     online && ACMCaseID !== null
                    //       ? notify({ type: 'warning',
                    //       message: 'This ACM case. You can\'t edit this value.' })
                    //       : online
                    //         ? _onLongPress(event, 'selectedTime')
                    //         : notify({ type: 'error',
                    //         message: 'You need an internet connection to edit this case.',
                    //         time: 5 });
                    //   },
                    //   LONG_PRESS_PARAMS)}
                    //   className={`cursor-pointer theme-color${
                    //   (ACMCaseID === null && screenWidth > 800) ? '-yellow'
                    //     : ((ACMCaseID === null || ACMCaseID !== null)
                    //     && screenWidth < 800) ? '-white'
                    //       : ((ACMCaseID === null || ACMCaseID !== null)
                    //       && (screenWidth > 800 || screenWidth < 800)) && '-white'}`}
                    // ><span className="case-time">{moment(selectedTime).format('h:mm A')}</span>
                    // </span>
                    <span
                      className={`theme-color-white ${acmRepLockData.includes('CASETIME') ? 'blue-text' : ''}`}
                    ><span className="case-time">{moment(selectedTime).format('h:mm A')}</span>
                    </span>
                  )
              }
            </div>
          </div>

          <div className="row gx-2 case-data mb-1">
            <div className="col-2"><label htmlFor="surgeon">Surgeon:</label></div>
            <div className="col-9">
              {
                (isEditDetail.SurgeonName)
                  ? (
                    <Select2
                      style={{ width: '100%', color: 'red' }}
                      className="form-control"
                      data={surgeons.map((value) => value.SurgeonName)}
                      value={SurgeonName}
                      id="onSelect2FocusEdit"
                      onChange={({ target: { value } }) => {
                        onChangeCaseDetail('SurgeonName', value);
                        _getHospital();
                      }}
                      options={{ placeholder: 'Select Surgeon' }}
                      disabled={(ACMCaseID !== null)}
                    />
                  )
                  : (
                    <p
                      className="theme-color-white"
                    >
                      {(SurgeonName === null || SurgeonName === '') ? <p style={{ color: 'grey', visibility: 'hidden' }}>SurgeonName</p>
                        : SurgeonName}
                    </p>
                  )
              }
            </div>
          </div>

          <div className="row gx-2 case-data mb-1">
            <div className="col-2"><label htmlFor="hospital">Hospital:</label></div>
            <div className="col-9">
              {
                (isEditDetail.CustomerName || isEditDetail.SurgeonName)
                  ? (
                    <Select2
                      style={{ width: '100%', color: 'red' }}
                      className="form-control"
                      data={hospitals.map((value) => value.CustomerName)}
                      value={CustomerName}
                      onChange={({ target: { value } }) => {
                        onChangeCaseDetail('CustomerName', value);
                        _getCustomerNo(value);
                      }}
                      id="hospitalsEle1"
                      required
                      options={{ placeholder: 'Select Hospital' }}
                      disabled={(ACMCaseID !== null)}
                    />
                  )
                  : (
                    <p
                      className={`theme-color-white ${screenWidth < 800 ? 'text-overflow-case-details' : ''}`}
                    >
                      {(CustomerName === null || CustomerName === '') ? <p style={{ color: 'grey', visibility: 'hidden' }}>CustomerName</p>
                        : CustomerName}
                    </p>
                  )
              }
            </div>
          </div>

          <div className="row gx-2 case-data mb-1">
            <div className="col-2"><label htmlFor="rep">Rep:</label></div>
            <div className="col-9">
              {
                (isEditDetail.CoverRep === true)
                  ? (
                    <Select2
                      style={{ width: '100%', color: 'red' }}
                      className="form-control"
                      data={coverReps.map((value) => value.SalesRepName)}
                      value={CoverRep}
                      id="onSelect2FocusEdit"
                      onChange={({ target: { value } }) => {
                        onChangeCaseDetail('CoverRep', value);
                        $('#onSelect2FocusEdit').select2('open');
                      }}
                      options={{ placeholder: 'Select Rep' }}
                    />
                  )
                  : (
                    <p
                      className="theme-color-white"
                    >
                      {(CoverRep === null || CoverRep === '') ? <p className="case-details-type-none">CoverRep</p>
                        : (CoverRep === 'NONE') ? <p className="case-details-type-none">NONE</p> : CoverRep}
                    </p>
                  )
              }
            </div>
          </div>

          <div className="row gx-2 case-data mb-1">
            <div className="col-2"><label htmlFor="type">Type:</label></div>
            <div className="col-9">
              {
                (isEditDetail.CaseType === true)
                  ? (
                    <Select2
                      style={{ width: '100%', color: 'red' }}
                      className="form-control"
                      data={types.map((value) => value.OptionName)}
                      value={CaseType}
                      id="onSelect2FocusEdit"
                      onChange={({ target: { value } }) => {
                        onChangeCaseDetail('CaseType', value);
                        $('#onSelect2FocusEdit').select2('open');
                      }}
                      options={{ placeholder: 'Select Type' }}
                      disabled={(ACMCaseID !== null)}
                    />
                  )
                  : (
                    // COMMENT currently quick edit functionality disabled
                    //     <span
                    //       {...useLongPress((event) => {
                    //         online && ACMCaseID !== null
                    //           ? notify({ type: 'warning',
                    //           message: 'This ACM case. You can\'t edit this value.' })
                    //           : online
                    //             ? _onLongPress(event, 'CaseType')
                    //             : notify({ type: 'error',
                    //             message: 'You need an internet connection to edit this case.',
                    //             time: 5 });
                    //       },
                    //       LONG_PRESS_PARAMS)}
                    //       className={`cursor-pointer theme-color${
                    //       (ACMCaseID === null && screenWidth > 800) ? '-yellow'
                    //         : ((ACMCaseID === null || ACMCaseID !== null)
                    //         && screenWidth < 800) ? '-white'
                    //           : ((ACMCaseID === null || ACMCaseID !== null)
                    //           && (screenWidth > 800 || screenWidth < 800)) && '-white'}`}
                    //     >
                    //       {(CaseType === null || CaseType === '')
                    //       ? <p style={{ color: 'grey', visibility: 'hidden' }}>CaseType</p>
                    //         : CaseType}
                    //     </span>
                    <span
                      className={`theme-color-white ${acmRepLockData.includes('PROCEDURETYPE') ? 'blue-text' : ''}`}
                    >
                      {
                        (AltCaseType !== null && AltCaseType !== '') ? AltCaseType
                          : (CaseType !== null && CaseType !== '') ? CaseType
                            : <p className="case-details-type-none">CaseType</p>
                      }
                      {(Side === null || Side === '') ? '' : (Side === 'NONE') ? '' : ','}
                    </span>
                  )
              }
              {
                (isEditDetail.ProcedureType === true)
                  ? (
                    <Select2
                      style={{ width: '100%', color: 'red' }}
                      className="form-control"
                      data={procedures.map((value) => value.OptionName)}
                      value={ProcedureType}
                      id="onSelect2FocusEdit"
                      onChange={({ target: { value } }) => {
                        onChangeCaseDetail('ProcedureType', value);
                        $('#onSelect2FocusEdit').select2('open');
                      }}
                      options={{ placeholder: 'Select side' }}
                      disabled={(ACMCaseID !== null)}
                    />
                  )
                  : (
                    <span
                      className={`theme-color-white ${acmRepLockData.includes('PROCEDURETYPE') ? 'blue-text' : ''}`}
                    >
                      {
                        (AltCaseType !== null && AltCaseType !== '') ? null
                          : (ProcedureType !== null && ProcedureType !== '') ? ProcedureType
                            : ''
                      }
                    </span>
                  )
              }
              {
                (isEditDetail.Side === true)
                  ? (
                    <Select2
                      style={{ width: '100%', color: 'red' }}
                      className="form-control"
                      data={sides.map((value) => value.OptionName)}
                      value={Side}
                      id="onSelect2FocusEdit"
                      onChange={({ target: { value } }) => {
                        onChangeCaseDetail('Side', value);
                        $('#onSelect2FocusEdit').select2('open');
                      }}
                      options={{ placeholder: 'Select side' }}
                      disabled={(ACMCaseID !== null)}
                    />
                  )
                  : (
                    // COMMENT currently quick edit functionality disabled
                    // <span
                    //   {...useLongPress((event) => {
                    //     online && ACMCaseID !== null
                    //       ? notify({ type: 'warning',
                    //       message: 'This ACM case. You can\'t edit this value.' })
                    //       : online
                    //         ? _onLongPress(event, 'Side')
                    //         : notify({ type: 'error',
                    //         message: 'You need an internet connection to edit this case.',
                    //         time: 5 });
                    //   },
                    //   LONG_PRESS_PARAMS)}
                    //   className={`cursor-pointer theme-color${
                    //   (ACMCaseID === null && screenWidth > 800) ? '-yellow'
                    //     : ((ACMCaseID === null || ACMCaseID !== null)
                    //     && screenWidth < 800) ? '-white'
                    //       : ((ACMCaseID === null || ACMCaseID !== null)
                    //       && (screenWidth > 800 || screenWidth < 800)) && '-white'}`}
                    // >
                    //   {(Side === null || Side === '')
                    //   ? <p style={{ color: 'grey', visibility: 'hidden' }}>Side</p>
                    //     : (Side === 'NONE') ?
                    //     <p style={{ color: 'grey', visibility: 'hidden' }}>NONE</p>
                    //       : `, ${Side}`}
                    // </span>
                    <span className={`theme-color-white ${acmRepLockData.includes('SIDE') ? 'blue-text' : ''}`}>
                      {(Side === null || Side === '') ? <p className="case-details-type-none">Side</p>
                        : (Side === 'NONE') ? <p className="case-details-type-none">NONE</p>
                          : ` ${Side}`}
                    </span>
                  )
              }
            </div>
          </div>

          <div className="row gx-2 case-data mb-1">
            <div className="col-2"><label htmlFor="patient">Patient:</label></div>
            <div className="col-9">
              {
                (isEditDetail.PatientID === true)
                  ? (
                    <input
                      type="text"
                      defaultValue={PatientID}
                      className="form-control text-overflow text-uppercase"
                      maxLength="50"
                      id="onFocusEdit"
                      onChange={(event) => onChangeCaseDetail('PatientID', event.target.value)}
                      disabled={(ACMCaseID !== null)}
                    />
                  )
                  : (
                    <p className="theme-color-white">
                      {(PatientID === null || PatientID === '') ? <p style={{ color: 'grey', visibility: 'hidden' }}>PatientID</p>
                        : (PatientID !== null && PatientID !== undefined && PatientID.startsWith('ACM CX'))
                          ? <p style={{ backgroundColor: 'red' }}>{PatientID}</p>
                          : <p className="text-uppercase text-overflow-case-details">{PatientID}</p>}
                    </p>
                  )
              }
            </div>
          </div>

          <div className="row gx-2 case-data mb-1">
            <div className="col-2"><label htmlFor="mrn">MRN:</label></div>
            <div className="col-9">
              {
                (isEditDetail.MRN === true)
                  ? (
                    <input
                      type="text"
                      defaultValue={MRN}
                      className="form-control text-overflow text-uppercase"
                      maxLength="50"
                      id="onFocusEdit"
                      onChange={(event) => onChangeCaseDetail('MRN', event.target.value)}
                      disabled={(ACMCaseID !== null)}
                    />
                  )
                  : (
                    // COMMENT currently quick edit functionality disabled
                    // <p
                    //   {...useLongPress((event) => {
                    //     online && ACMCaseID !== null
                    //       ? notify({ type: 'warning',
                    //       message: 'This ACM case. You can\'t edit this value.' })
                    //       : _onLongPress(event, 'MRN');
                    //   },
                    //   LONG_PRESS_PARAMS)}
                    //   className={`cursor-pointer theme-color${
                    //   (ACMCaseID === null && screenWidth > 800) ? '-yellow'
                    //     : ((ACMCaseID === null || ACMCaseID !== null)
                    //     && screenWidth < 800) ? '-white'
                    //       : ((ACMCaseID === null || ACMCaseID !== null)
                    //       && (screenWidth > 800 || screenWidth < 800)) && '-white'}`}
                    // >
                    //   {(MRN === null || MRN === '')
                    //   ? <p style={{ color: 'grey', visibility: 'hidden' }}>MRN</p>
                    //     : <p className=" text-uppercase text-overflow-case-details">{MRN}</p>}
                    // </p>
                    <p className="theme-color-white">
                      {(MRN === null || MRN === '') ? <p style={{ color: 'grey', visibility: 'hidden' }}>MRN</p>
                        : <p className=" text-uppercase text-overflow-case-details">{MRN}</p>}
                    </p>
                  )
              }
            </div>
          </div>

          <div className="row gx-2 case-data mb-1">
            <div className="col-2"><label htmlFor="gender">Gender:</label></div>
            <div className="col-9">
              {
                (isEditDetail.Gender === true)
                  ? (
                    <Select2
                      style={{ width: '100%', color: 'red' }}
                      className="form-control"
                      data={genders.map((value) => value.OptionName)}
                      value={Gender}
                      id="onSelect2FocusEdit"
                      onChange={({ target: { value } }) => {
                        onChangeCaseDetail('Gender', value);
                        $('#onSelect2FocusEdit').select2('open');
                      }}
                      options={{ placeholder: 'Select gender' }}
                      disabled={(ACMCaseID !== null)}
                    />
                  )
                  : (
                    // COMMENT currently quick edit functionality disabled
                    // <p
                    //   {...useLongPress((event) => {
                    //     online && ACMCaseID !== null
                    //       ? notify({ type: 'warning',
                    //       message: 'This ACM case. You can\'t edit this value.' })
                    //       : online
                    //         ? _onLongPress(event, 'Gender')
                    //         : notify({ type: 'error',
                    //         message: 'You need an internet connection to edit this case.',
                    //         time: 5 });
                    //   },
                    //   LONG_PRESS_PARAMS)}
                    //   className={`cursor-pointer theme-color${
                    //   (ACMCaseID === null && screenWidth > 800) ? '-yellow'
                    //     : ((ACMCaseID === null || ACMCaseID !== null)
                    //     && screenWidth < 800) ? '-white'
                    //       : ((ACMCaseID === null || ACMCaseID !== null)
                    //       && (screenWidth > 800 || screenWidth < 800)) && '-white'}`}
                    // >
                    //   {(Gender === null || Gender === '')
                    //   ? <p style={{ color: 'grey', visibility: 'hidden' }}>Gender</p>
                    //     : (Gender === 'NONE') ?
                    //     <p style={{ color: 'grey', visibility: 'hidden' }}>NONE</p> : Gender}
                    // </p>
                    <p className="theme-color-white">
                      {(Gender === null || Gender === '') ? <p style={{ color: 'grey', visibility: 'hidden' }}>Gender</p>
                        : (Gender === 'NONE') ? <p style={{ color: 'grey', visibility: 'hidden' }}>NONE</p> : Gender}
                    </p>
                  )
              }
            </div>
          </div>

          <div className="row gx-2 case-data mb-1">
            <div className="col-2"><label htmlFor="age">Age:</label></div>
            <div className="col-9">
              {
                (isEditDetail.Age === true)
                  ? (
                    <input
                      type="number"
                      defaultValue={Age}
                      className="form-control"
                      maxLength="3"
                      id="onFocusEdit"
                      onChange={(event) => onChangeCaseDetail('Age', event.target.value)}
                      disabled={(ACMCaseID !== null)}
                      onInput={_maxLengthCheck}
                      onKeyDown={(e) => (
                        e.keyCode === 69 || e.keyCode === 190) && e.preventDefault()}
                    />
                  )
                  : (
                    // COMMENT currently quick edit functionality disabled
                    // <p
                    //   {...useLongPress((event) => {
                    //     online && ACMCaseID !== null
                    //       ? notify({ type: 'warning',
                    //       message: 'This ACM case. You can\'t edit this value.' })
                    //       : online
                    //         ? _onLongPress(event, 'Age')
                    //         : notify({ type: 'error',
                    //         message: 'You need an internet connection to edit this case.',
                    //         time: 5 });
                    //   },
                    //   LONG_PRESS_PARAMS)}
                    //   className={`cursor-pointer theme-color${
                    //   (ACMCaseID === null && screenWidth > 800) ? '-yellow'
                    //     : ((ACMCaseID === null || ACMCaseID !== null)
                    //     && screenWidth < 800) ? '-white'
                    //       : ((ACMCaseID === null || ACMCaseID !== null)
                    //       && (screenWidth > 800 || screenWidth < 800)) && '-white'}`}
                    // >
                    //   {(Age === null || Age === '')
                    //   ? <p style={{ color: 'grey', visibility: 'hidden' }}>Age</p> : Age}
                    // </p>
                    <p className="theme-color-white">
                      {(Age === null || Age === '') ? <p style={{ color: 'grey', visibility: 'hidden' }}>Age</p> : Age}
                    </p>
                  )
              }
            </div>
          </div>

          <div className="row gx-2 case-data mb-1">
            <div className="col-2"><label htmlFor="height">Height:</label></div>
            <div className="col-9">
              {
                (isEditDetail.Height === true)
                  ? (
                    <input
                      type="text"
                      defaultValue={Height}
                      className="form-control"
                      maxLength="25"
                      id="onFocusEdit"
                      onChange={(event) => onChangeCaseDetail('Height', event.target.value)}
                      disabled={(ACMCaseID !== null)}
                    />
                  )
                  : (
                    // COMMENT currently quick edit functionality disabled
                    // <p
                    //   {...useLongPress((event) => {
                    //     online && ACMCaseID !== null
                    //       ? notify({ type: 'warning',
                    //       message: 'This ACM case. You can\'t edit this value.' })
                    //       : online
                    //         ? _onLongPress(event, 'Height')
                    //         : notify({ type: 'error',
                    //         message: 'You need an internet connection to edit this case.',
                    //         time: 5 });
                    //   },
                    //   LONG_PRESS_PARAMS)}
                    //   className={`cursor-pointer theme-color${
                    //   (ACMCaseID === null && screenWidth > 800) ? '-yellow'
                    //     : ((ACMCaseID === null || ACMCaseID !== null)
                    //     && screenWidth < 800) ? '-white'
                    //       : ((ACMCaseID === null || ACMCaseID !== null)
                    //       && (screenWidth > 800 || screenWidth < 800)) && '-white'}`}
                    // >
                    //   {(Height === null || Height === '')
                    //   ? <p style={{ color: 'grey', visibility: 'hidden' }}>Height</p> : Height}
                    // </p>
                    <p className="theme-color-white">
                      {
                        (Height === null || Height === '')
                          ? <p style={{ color: 'grey', visibility: 'hidden' }}>Height</p>
                          : Height
                      }

                      {
                        (HeightUnits === null || HeightUnits === '')
                          ? <p style={{ color: 'grey', visibility: 'hidden' }} />
                          : ` ${HeightUnits}`
                      }
                    </p>
                  )
              }
            </div>
          </div>

          <div className="row gx-2 case-data mb-1">
            <div className="col-2"><label htmlFor="weight">Weight:</label></div>
            <div className="col-9">
              {
                (isEditDetail.Weight === true)
                  ? (
                    <input
                      type="text"
                      defaultValue={Weight}
                      className="form-control"
                      maxLength="25"
                      id="onFocusEdit"
                      onChange={(event) => onChangeCaseDetail('Weight', event.target.value)}
                      disabled={(ACMCaseID !== null)}
                    />
                  )
                  : (
                    // COMMENT currently quick edit functionality disabled
                    // <p
                    //   {...useLongPress((event) => {
                    //     online && ACMCaseID !== null
                    //       ? notify({ type: 'warning',
                    //       message: 'This ACM case. You can\'t edit this value.' })
                    //       : online
                    //         ? _onLongPress(event, 'Weight')
                    //         : notify({ type: 'error',
                    //         message: 'You need an internet connection to edit this case.',
                    //         time: 5 });
                    //   },
                    //   LONG_PRESS_PARAMS)}
                    //   className={`cursor-pointer theme-color${
                    //   (ACMCaseID === null && screenWidth > 800) ? '-yellow'
                    //     : ((ACMCaseID === null || ACMCaseID !== null)
                    //     && screenWidth < 800) ? '-white'
                    //       : ((ACMCaseID === null || ACMCaseID !== null)
                    //       && (screenWidth > 800 || screenWidth < 800)) && '-white'}`}
                    // >
                    //   {(Weight === null || Weight === '')
                    //   ? <p style={{ color: 'grey', visibility: 'hidden' }}>Weight</p> : Weight}
                    // </p>
                    <p className="theme-color-white">
                      {
                        (Weight === null || Weight === '')
                          ? <p style={{ color: 'grey', visibility: 'hidden' }}>Weight</p>
                          : Weight
                      }
                      {
                        (WeightUnits === null || WeightUnits === '')
                          ? <p style={{ color: 'grey', visibility: 'hidden' }} />
                          : ` ${WeightUnits}`
                      }
                    </p>
                  )
              }
            </div>
          </div>

          <div className="row gx-2 case-data mb-1">
            <div className={`col-3 col-md-2 ${screenWidth < 800 ? 'case-details-RepPo' : ''}`}><label htmlFor="rep_po">Rep PO#:</label></div>
            <div className={`col-9 col-md-10 ${screenWidth < 800 ? 'ps-0' : ''}`}>
              {
                isEditDetail.RepPONumber ? (
                  <p className="theme-color-yellow">
                    <input
                      id="onFocusEdit"
                      type="text"
                      defaultValue={RepPONumber}
                      className="form-control text-overflow text-uppercase"
                      maxLength="50"
                      onChange={(event) => onChangeCaseDetail('RepPONumber', event.target.value)}
                    />
                  </p>
                )
                  : (
                    // COMMENT currently quick edit functionality disabled
                    // <p
                    //   className={`cursor-pointer theme-color${screenWidth > 800 ? '-yellow'
                    //     : screenWidth < 800 ? '-white'
                    //     : (ACMCaseID === null || ACMCaseID !== null) && '-white'}`}
                    //   {...useLongPress((event) => {
                    //     online
                    //       ? _onLongPress(event, 'RepPONumber')
                    //       : notify({ type: 'error',
                    //       message: 'You need an internet connection to edit this case.',
                    //       time: 5 });
                    //   },
                    //   LONG_PRESS_PARAMS)}
                    // >
                    //   {(RepPONumber === null || RepPONumber === '')
                    //   ? <p style={{ color: 'grey', visibility: 'hidden' }}>RepPO Number</p>
                    //     : <p className="text-uppercase">{RepPONumber}</p>}
                    // </p>
                    <p className="theme-color-white">

                      {(RepPONumber === null || RepPONumber === '') ? <p style={{ color: 'grey', visibility: 'hidden' }}>RepPO Number</p>
                        : <p className="text-uppercase">{RepPONumber}</p>}
                    </p>
                  )
              }
            </div>
          </div>

          <div className="row gx-2 case-data mb-1">
            <div className="col-12"><label htmlFor="rep_notes">Rep Notes (not seen by office staff)</label></div>
            <div className="col-12">
              {
                isEditDetail.RepNotes ? (
                  <p className="theme-color-yellow uc-first-letter">
                    <textarea
                      id="repNote"
                      defaultValue={RepNotes}
                      className="form-control"
                      autoCapitalize="on"
                      onChange={(event) => onChangeCaseDetail('RepNotes', window.UCFirst(event.target.value))}
                    />
                  </p>
                )
                  : (
                    // COMMENT currently quick edit functionality disabled
                    // <p
                    //   className={`cursor-pointer theme-color${screenWidth > 800 ? '-yellow'
                    //     : screenWidth < 800 ? '-white'
                    //     : (ACMCaseID === null || ACMCaseID !== null) && '-white'}`}
                    //   {...useLongPress((event) => {
                    //     online
                    //       ? _onLongPress(event, 'RepNotes')
                    //       : notify({ type: 'error',
                    //       message: 'You need an internet connection to edit this case.',
                    //       time: 5 });
                    //   },
                    //   LONG_PRESS_PARAMS)}
                    //   dangerouslySetInnerHTML={{
                    //     __html: (RepNotes && RepNotes !== null)
                    //       ? RepNotes.replace(/(?:\r\n|\r|\n)/g, '<br />')
                    //       : '<p style="color: gray">Add Notes</p>'
                    //   }}
                    // />
                    <p
                      className="theme-color-white"
                      dangerouslySetInnerHTML={{
                        __html: (RepNotes && RepNotes !== null)
                          ? RepNotes.replace(/(?:\r\n|\r|\n)/g, '<br />')
                          : '<p style="color: gray"></p>'
                      }}
                    />
                  )
              }
            </div>
          </div>

          <div className="row gx-2 case-data">
            <div className="col-12"><label htmlFor="office_notes">Office Notes</label></div>
            <div className="col-12">
              {
                isEditDetail.Comments ? (
                  <p className="theme-color-yellow uc-first-letter">
                    <textarea
                      id="officeNote"
                      defaultValue={Comments}
                      className="form-control"
                      onChange={(event) => onChangeCaseDetail('Comments', window.UCFirst(event.target.value))}
                    />
                  </p>
                )
                  : (
                    <p
                      className="theme-color-whit}"
                      dangerouslySetInnerHTML={{
                        __html: (Comments && Comments !== null)
                          ? Comments.replace(/(?:\r\n|\r|\n)/g, '<br />')
                          : '<p style="color: gray"></p>'
                      }}
                    />
                  )
              }
            </div>
          </div>

          <div className="row gx-2 case-data mb-1">
            {
              ACMCaseID !== null
              && (
                <>
                  <div className="col-12">
                    <label htmlFor="clinical_notes">Clinical Notes</label>
                  </div>
                  <div className="col-9">
                    {
                      isEditDetail.Comments ? (
                        <p className="theme-color-yellow">
                          <textarea
                            id="clinicalNote"
                            defaultValue={SurgeonNotes}
                            className="form-control"
                            placeholder="SurgeonNotes"
                            style={{ backgroundColor: '#212121', borderColor: '#212121' }}
                            onChange={(event) => onChangeCaseDetail('SurgeonNotes', (event.target.value))}
                            disabled
                          />
                        </p>
                      )
                        : (
                          <p dangerouslySetInnerHTML={{
                            __html: (SurgeonNotes && SurgeonNotes !== null)
                              ? SurgeonNotes.replace(/(?:\r\n|\r|\n)/g, '<br />')
                              : '<p style="color: gray"></p>'
                          }}
                          />
                        )
                    }
                  </div>
                </>
              )
            }
          </div>

          <div className="row gx-2 case-data mb-1">
            {
              ACMCaseID !== null && (
                <div className="col-2" style={{ color: '#9e9e9e', width: '70px' }}>
                  <label htmlFor="clinical_notes">Templated:</label>
                </div>
              )
            }
            <div className="col-9">
              {
                acmPlanned.map((planned, key) => (
                  <span>
                    {
                      key !== 0
                        ? `, ${planned.longDesc}`
                        : planned.longDesc
                    }
                  </span>
                ))
              }
            </div>
          </div>

          {
            online ? (xRayFileUrlDataToShow.length > 0)
              ? (
                <div className="xrays-doclist mb-5 scroll-area">
                  {
                    xRayFileUrlDataToShow.filter((f) => f.type === 'pdf').length > 0
                      ? xRayFileUrlDataToShow.filter((f) => f.type === 'pdf')[0].files.map((pdf, k) => (
                        <Link
                          to={pdf.src} target="_blank"
                          className="items text-center" key={k}
                        >
                          <span className="pdficon">
                            <img src={PdfIcon} alt="pdficon" />
                          </span>
                        </Link>
                      )) : ''
                  }
                  {
                    xRayFileUrlDataToShow.filter((f) => f.type === 'txt').length > 0
                      ? xRayFileUrlDataToShow.filter((f) => f.type === 'txt')[0].files.map((txt, k) => (
                        <Link
                          to={txt.src} target="_blank"
                          className="items text-center" key={k}
                        >
                          <span className="fileicon">
                            <img src={FileIcon} alt="fileicon" />
                          </span>
                        </Link>
                      )) : ''
                  }
                  {
                    xRayFileUrlDataToShow.filter((f) => f.type === 'image').length > 0
                      ? (
                        xRayFileUrlDataToShow.filter((f) => f.type === 'image')[0].files.map((ig, i) => (
                          <div
                            onClick={() => {
                              if (ig?.loaded) {
                                onImage(ig);
                              }
                            }}
                            className="items" key={i}
                          >
                            <ImageWithLoader
                              src={ig.src} alt={ig.title}
                              onImageLoad={() => {
                                ig.loaded = true;
                              }}
                            />
                            { /* <span className="title">{ig.title}</span> */}
                          </div>
                        ))
                      ) : ''
                  }
                  {xRayCount > 20
                    && (
                      <Link
                        onClick={_onXrays}
                        className="items text-center cursor-pointer view-all-link"
                      >
                        <span>
                          <p>View All</p>
                        </span>
                      </Link>
                    )}
                </div>
              ) : ''
              : (
                <div className="xrays-doclist mb-5 scroll-area">
                  {xRayFileUrlDataToShow.map((item, key) => (
                    <div
                      key={key}
                      onClick={() => {
                        notify({ type: 'error', message: 'X-rays cannot be viewed without an internet connection.', time: 3 });
                      }}
                      className="offline-xray-list"
                    />
                  ))}
                </div>
              )
          }

          {
            setsQuantity !== {} && (
              <div className="row gx-2 case-data mb-1">
                <div className="col-12 mb-2"><label htmlFor="caseId">Planned Sets:</label></div>
                <div className="col-12">
                  {
                    Object.keys(_getOfficeSets()).length > 0
                      ? Object.keys(_getOfficeSets()).map((sets) => (
                        <div key={sets}>
                          <p className="setName mb-0">
                            {sets.toLowerCase()}{(_getOfficeSets()[sets]).length > 1 ? 's: ' : ': '}
                            {
                              (
                                // _getOfficeSets()[sets].reduce(
                                //   (total, currentValue) => (total + +currentValue.Quantity), 0
                                // )

                                Number(getTotalQuantity(caseRes.case_sets, sets, true))
                                + Number(getTotalQuantity(caseRes.all_case_sets, sets, false))
                                + Number(getTotalQuantity(caseRes.case_sets_removedcx, sets, false))
                              )
                            }
                          </p>

                          <table className="table table-bordered plan-table">
                            <tbody>
                              {
                                caseRes.case_sets.length > 0 && caseRes.case_sets.filter(
                                  (items) => (items.DeviceType === sets && items.Status === null)
                                ).length > 0
                                  ? (
                                    caseRes.case_sets.map((set, s) => (
                                      (set.DeviceType === sets && set.Status === null)
                                        ? (Number(set.Quantity) > 1)
                                          ? (
                                            <LoopComponent setData={set} />
                                          )
                                          : (
                                            <tr className={s} key={s}>
                                              <td className="col-11">{set.SetName}</td>
                                              <td className="col-1 text-center">
                                                {
                                                  typeof set.SetNo !== 'undefined' && set.SetNo !== null
                                                    ? (
                                                      set.SetNo.length > 2
                                                        ? set.SetNo.slice(0, 2) : set.SetNo
                                                    )
                                                    : ''
                                                }
                                              </td>
                                            </tr>
                                          )
                                        : ''
                                    ))
                                  )
                                  : ''
                              }

                              {/* {
                                typeof caseRes.case_sets_ec !== 'undefined'
                                && caseRes.case_sets_ec.length > 0
                                && caseRes.case_sets_ec.filter(
                                  (items) => (items.DeviceType === sets)
                                ).length > 0
                                  ? (
                                    caseRes.case_sets_ec.map((set, s) => (
                                      (set.DeviceType === sets)
                                        ? (Number(set.Quantity) > 1)
                                          ? (
                                            <LoopComponent setData={set} />
                                          )
                                          : (
                                            <tr className={s} key={s}>
                                              <td className="col-11">{set.SetName}</td>
                                              <td className="col-1 text-center">
                                                {
                                                  typeof set.SetNo !== 'undefined'
                                                  && set.SetNo !== null
                                                    ? (
                                                      set.SetNo.length > 2
                                                        ? set.SetNo.slice(0, 2) : set.SetNo
                                                    )
                                                    : ''
                                                }
                                              </td>
                                            </tr>
                                          )
                                        : ''
                                    ))
                                  )
                                  : ''
                              } */}

                              {
                                typeof caseRes.case_sets_removedcx !== 'undefined' && caseRes.case_sets_removedcx.length > 0 && caseRes.case_sets_removedcx.filter(
                                  (items) => (items.DeviceType === sets)
                                ).length > 0
                                  ? (
                                    caseRes.case_sets_removedcx.map((set, s) => (
                                      (set.DeviceType === sets)
                                        ? (Number(set.Quantity) > 1)
                                          ? (
                                            <LoopComponent setData={set} />
                                          )
                                          : (
                                            <tr className={s} key={s}>
                                              <td className="col-11">{set.SetName}</td>
                                              <td className="col-1 text-center">
                                                {
                                                  typeof set.SetNo !== 'undefined' && set.SetNo !== null
                                                    ? (
                                                      set.SetNo.length > 2
                                                        ? set.SetNo.slice(0, 2) : set.SetNo
                                                    )
                                                    : ''
                                                }
                                              </td>
                                            </tr>
                                          )
                                        : ''
                                    ))
                                  )
                                  : ''
                              }

                              {
                                typeof caseRes.all_case_sets !== 'undefined' && caseRes.all_case_sets.length > 0 && caseRes.all_case_sets.filter(
                                  (items) => (items.DeviceType === sets)
                                ).length > 0
                                  ? (
                                    caseRes.all_case_sets.map((set, s) => (
                                      (set.DeviceType === sets)
                                        ? (Number(set.Quantity) > 1)
                                          ? (
                                            <LoopComponent setData={set} />
                                          )
                                          : (
                                            <tr className={s} key={s}>
                                              <td className="col-11">{set.SetName}</td>
                                              <td className="col-1 text-center">
                                                {
                                                  typeof set.SetNo !== 'undefined' && set.SetNo !== null
                                                    ? (
                                                      set.SetNo.length > 2
                                                        ? set.SetNo.slice(0, 2) : set.SetNo
                                                    )
                                                    : ''
                                                }
                                              </td>
                                            </tr>
                                          )
                                        : ''
                                    ))
                                  )
                                  : ''
                              }
                            </tbody>
                          </table>

                          {
                            typeof caseRes.case_sets_rbo !== 'undefined' && caseRes.case_sets_rbo.length > 0 && caseRes.case_sets_rbo.filter(
                              (items) => (items.DeviceType === sets)
                            ).length > 0
                              ? (
                                <>
                                  <p className="mb-0">
                                    <label htmlFor="caseId">Removed by Office (check above for replacement) </label>
                                  </p>
                                  <table className="table table-bordered plan-table w-92">
                                    <tbody>
                                      {
                                        (caseRes.case_sets_rbo.map((item, i) => (
                                          (item.DeviceType === sets)
                                            ? (
                                              <tr className={i} key={i}>
                                                <td className="col-12">{item.SetName}</td>
                                              </tr>
                                            )
                                            : ''
                                        )))
                                      }
                                    </tbody>
                                  </table>
                                </>
                              )
                              : ''
                          }
                        </div>
                      )) : ''
                  }
                </div>
              </div>
            )
          }
        </div>

        <CaseChangesNoLonger id={caseId} />
        <DgrRequiredOnSubmitCase
          onClickYes={onClickDrgModalYes}
          id={caseId}
        />
      </section>

      <div className="navbar-bottom">
        <div className="footer-nav-container">
          <div className="d-flex justify-content-around">
            <Link onClick={_onCancelCase}><img width="24px" src={CloseIcon} alt="xray" /><span>Cancel</span></Link>
            <Link onClick={_onXrays}><img width="24px" src={XrayIcon} alt="xray" />
              <span>{case_xrays !== undefined && case_xrays.length === 0 ? 'X-rays'
                : case_xrays !== undefined && case_xrays.length && case_xrays.length === 1 ? 'X-ray' : 'X-rays'}
              </span>
            </Link>
            <Link style={{ paddingTop: '19px' }} onClick={_onSets}>
              <span>
                <i className="set-count" style={{ fontSize: 'large' }}>{setsQuantity !== {} ? setsQuantity : 0}</i>
              </span>
              <span>{setsQuantity !== {} && setsQuantity === 0 ? 'Sets'
                : setsQuantity !== {} && setsQuantity === 1 ? 'Set' : 'Sets'}
              </span>
            </Link>
            <Link style={{ paddingTop: '19px' }} onClick={() => onBeforeProduct()}>
              <span>
                <i className="set-count" style={{ fontSize: 'large' }}>
                  {case_products !== undefined ? case_products.length : 0}
                </i>
              </span>
              <span>{case_products !== undefined && case_products.length === 0 ? 'Products'
                : case_products !== undefined && case_products.length === 1 ? 'Product' : 'Products'}
              </span>
            </Link>
            <Link style={{ paddingTop: '19px' }} onClick={_onBillingDetails}>
              <img width="20px" src={DollarSign} alt="billing" />
              <span>Billing</span>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}

export default withTableName(
  withLoader(
    withProducts(
      withOnline(
        withGoBack(
          withNotify(
            withTeam(
              withDerModal(
                withThemeColor(
                  EditCaseDetail
                )
              )
            )
          )
        )
      )
    )
  )
);
